import type {Advertisement} from '@/modules/hotels/components/List/components/UpliftAds/models';

import styled from '@emotion/styled';
import axios from 'axios';

import {Banner} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner';

type Props = {
  advertisements?: Array<Advertisement>;
  className?: string;
  category?: string;
  width?: string;
  height?: string;
};

export const UpliftAds = styled(
  ({
    advertisements,
    className = '',
    category = 'hero',
    width,
    height,
  }: Props) => {
    if (!advertisements || advertisements.length <= 0) {
      return null;
    }

    return (
      <>
        {advertisements.map((advertisement: Advertisement) => {
          const {
            adId,
            flightId,
            impressionUrl,
            viewableImpressionUrl,
            clickUrl,
            creativeContent,
          } = advertisement;
          return (
            <Banner
              category={category}
              key={adId}
              content={{...creativeContent[0], ctPrice: '450'}} // TODO fix price when BE will available
              onClick={() => window.open(clickUrl)}
              onRender={() => axios.get(impressionUrl)}
              onHasBeenVisible={() => axios.get(viewableImpressionUrl)}
              className={`FID_${flightId} ${className}`}
              width={width}
              height={height}
            />
          );
        })}
      </>
    );
  }
)``;
